module.exports = __webpack_public_path__ + "static/img/art-b.2087c7ad.png";